import { createFileRoute } from '@tanstack/react-router';
import ApprovalModule from '@/modules/ess/leave/approval/ApprovalModule';

export const Route = createFileRoute('/(dashboard)/_dashboard/ess/leave/$id')({
  component: ApprovalModule,
});
